import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { UtensilsCrossed, Scissors, HardHat, Wrench } from 'lucide-react';
const industries = [{
  name: 'Restaurantes',
  icon: UtensilsCrossed
}, {
  name: 'Barberías',
  icon: Scissors
}, {
  name: 'Construcción',
  icon: HardHat
}, {
  name: 'Servicios',
  icon: Wrench
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function TrustBar() {
  return <section className="bg-brand-charcoal py-12 border-y border-brand-gold/10" data-id="element-102">
      <div className="max-w-6xl mx-auto px-4" data-id="element-103">
        <motion.div className="flex flex-wrap justify-center gap-8 md:gap-16 lg:gap-24" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-104">
          {industries.map(industry => <motion.div key={industry.name} className="flex flex-col items-center gap-3" variants={itemVariants} data-id="element-105">
              <industry.icon className="w-8 h-8 text-brand-gold" strokeWidth={1.5} data-id="element-106" />
              <span className="text-sm md:text-base font-medium text-gray-400 tracking-wider uppercase" data-id="element-107">
                {industry.name}
              </span>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}